<template>
  <div class="upload-pictures-wrapper">
    <div class="picture-count">
      <div class="Nav">
        <div class="trees-coadd">
          <div class="scollhide">
            <div class="trees">
              <el-tree ref="treeRef" :data="treeData2" :props="defaultProps" node-key="attachmentCategoryId"
                :highlight-current="true" :expand-on-click-node="false" @nodeClick="appendBtn"
                :current-node-key="treeId">
                <template #default="{ node, data }">
                  <div class="custom-tree-node">
                    <div class="line1">
                      <span>{{ node.label }}</span>
                    </div>
                    <span @click.stop>
                      <!-- EP 无 el-icon-more 字体；用 MoreFilled 对齐 EB 分类「…」设置入口 -->
                      <el-dropdown trigger="click" @command="command => clickMenu(data, command)">
                        <span class="add">
                          <el-icon :size="14"><MoreFilled /></el-icon>
                        </span>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item command="1">新增分类</el-dropdown-item>
                            <el-dropdown-item v-if="data.attachmentCategoryId" command="2">编辑分类</el-dropdown-item>
                            <el-dropdown-item v-if="data.attachmentCategoryId" command="3">删除</el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </span>
                  </div>
                </template>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
      <div v-loading="loading" class="conter ml-20">
        <div class="flex-between-center mb-20">
          <!-- 左侧：按钮与级联同高、同行居中（对齐 EB small） -->
          <div class="acea-row row-middle pic-toolbar-left">
            <el-button v-if="params !== '/merchant/config/picture'" size="small" type="primary"
              @click="checkPics(true)">使用选中图片</el-button>
            <el-button size="small" class="upload-demo" type="primary" @click="uploadModal">上传图片</el-button>
            <el-button v-if="isPage" type="success" size="small" @click.stop="onAdd(0)">添加分类</el-button>
            <el-button type="danger" size="small" :disabled="ids.length === 0"
              @click.stop="deletePicList('图片')">删除图片</el-button>
            <el-cascader
              v-model="pids"
              placeholder="图片移动至"
              style="width: 150px"
              class="treeSel"
              :options="treeData2"
              :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'attachmentCategoryName',
                value: 'attachmentCategoryId'
              }"
              clearable
              size="small"
              @visibleChange="handleSelClick"
            />
          </div>
          <!-- 右侧：对齐 EB — 内嵌搜索图标 + 紧凑视图切换，同一行等高 -->
          <div class="acea-row row-middle pic-toolbar-right">
            <el-input
              v-model="tableData.attachmentName"
              class="mr-14 pic-search-input"
              style="width: 160px"
              size="small"
              placeholder="请输入图片名称搜索"
              @keyup.enter="getFileList(1)"
              @change="() => getFileList()"
            >
              <template #suffix>
                <el-icon class="pic-search-icon" @click="getFileList(1)">
                  <Search />
                </el-icon>
              </template>
            </el-input>
            <el-radio-group
              v-if="isPage"
              v-model="lietStyle"
              size="small"
              class="pic-view-toggle"
              @change="radioChange"
            >
              <el-radio-button value="list">
                <i class="iconfont icongongge"></i>
              </el-radio-button>
              <el-radio-button value="table">
                <i class="iconfont iconliebiao"></i>
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="relative upload-body">
          <div class="absolute upload-body-content">
            <div class="pictrueList acea-row" :class="{ 'is-modal': !isPage }">
              <div v-if="lietStyle == 'list'" style="width: 100%">
                <div v-show="isShowPic" class="imagesNo">
                  <i class="el-icon-picture" style="font-size: 60px;color: rgb(219, 219, 219);" />
                  <span class="imagesNo_sp">图片库为空</span>
                </div>
                <div class="conters" ref="imgListBoxRef">
                  <div v-for="(item, index) in pictrueList.list" :key="item.attachmentId" class="gridPic"
                    :class="{ gridSmall: isDialog }">
                    <p class="number" v-if="item.num > 0">
                      <el-badge class="item" :value="item.num">
                        <a href="#" class="demo-badge"></a>
                      </el-badge>
                    </p>
                    <div class="img" :class="item.isSelect ? 'on' : ''"
                      @click="changImage(item, index, pictrueList.list)">
                      <img :src="item.src || item.attachmentSrc" />
                    </div>
                    <div class="operate-item" @mouseenter="enterLeave(item)" @mouseleave="enterLeave(item)">
                      <p v-if="!item.isEdit">
                        {{ item.attachmentName }}
                      </p>
                      <el-input size="small" type="primary" v-model="item.attachmentName" v-else
                        @blur="handleEdit(item)" />
                      <div class="operate-item operate-height">
                        <span class="operate mr10" @click="deletePic(item)" v-if="item.isShowEdit">删除</span>
                        <span class="operate mr10" @click="item.isEdit = !item.isEdit" v-if="item.isShowEdit">重命名</span>
                        <span class="operate" @click="lookImg(item)" v-if="item.isShowEdit">查看</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-table v-if="lietStyle == 'table'" ref="tableRef" size="small" :data="pictrueList.list"
                v-loading="loading" highlight-row :row-key="getRowKey" @selectionChange="handleSelectRow" class="ones"
                no-data-text="暂无数据" no-filtered-data-text="暂无筛选结果">
                <el-table-column type="selection" width="60" :reserve-selection="true">
                </el-table-column>
                <el-table-column label="图片名称" min-width="190">
                  <template #default="scope">
                    <div class="df-aic">
                      <div class="tabBox_img mr10" v-viewer>
                        <img :src="scope.row.src || scope.row.attachmentSrc" alt="" />
                      </div>
                      <span v-if="!scope.row.isEdit" class="line2 real-name">{{
                        scope.row.attachmentName
                      }}</span>
                      <el-input size="small" type="primary" style="width: 90%" v-model="scope.row.attachmentName"
                        v-else @blur="handleEdit(scope.row)" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="上传时间" min-width="100">
                  <template #default="scope">
                    <span>{{ scope.row.createTime }}</span>
                  </template>
                </el-table-column>
                <!-- 对齐 EB：type=text → EP link，一行文字链不换行 -->
                <el-table-column label="操作" fixed="right" min-width="170" width="180">
                  <template #default="scope">
                    <div class="pic-table-ops">
                      <el-button type="primary" link size="small" @click="deletePic(scope.row)">删除</el-button>
                      <el-button
                        type="primary"
                        link
                        size="small"
                        @click="scope.row.isEdit = !scope.row.isEdit"
                      >{{ scope.row.isEdit ? '确定' : '重命名' }}</el-button>
                      <el-button type="primary" link size="small" @click="lookImg(scope.row)">查看</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="footer-page">
          <div class="flex-y-center">
            <el-checkbox v-model="allSelect" @change="selectAll">全选</el-checkbox>
            <span class="fs-12 pl-8">已选 {{ checkPicList.length }} 个</span>
          </div>
          <el-pagination background :pager-count="5" :page-size="tableData.limit" :current-page="tableData.page"
            layout="total, prev, pager, next, jumper" :total="pictrueList.total" @sizeChange="handleSizeChange"
            @currentChange="pageChange" />
        </div>
      </div>
    </div>
    <uploadImg ref="uploadRef" :isPage="isPage" :isIframe="isIframe" :categoryId="treeId" :categoryList="treeData"
      @uploadSuccess="uploadSuccess"></uploadImg>
    <div class="images" v-show="false" v-viewer="{ movable: false }">
      <img v-for="src in pictrueList.list" :src="src.attachmentSrc" :key="src.attachmentId" />
    </div>
  </div>
</template>

<script setup lang="ts">

import { ref, reactive, computed, watch, onMounted, nextTick, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { MoreFilled, Search } from '@element-plus/icons-vue'
import {
  formatLstApi,
  attachmentCreateApi,
  attachmentUpdateApi,
  picNameEditApi,
  attachmentDeleteApi,
  attachmentListApi,
  picDeleteApi,
  categoryApi
} from '@/api/system'
import { getToken } from '@/utils/auth'
import SettingMer from '@/libs/settingMer'
import uploadImg from '@/components/uploadImg/index.vue'
import { useFormCreateHelper } from '@/composables/useFormCreateHelper'

const { proxy } = getCurrentInstance()!
const route = useRoute()
const { getFieldValue, setFieldValue, closeField, onOk } = useFormCreateHelper()

/* ─── Types ─── */
interface Props {
  isMore?: string
  setModel?: string
  isIframe?: boolean
  isPage?: boolean
  pageLimit?: number
}

interface TableData {
  page: number
  limit: number
  attachmentCategoryId: number
  order: string
  attachmentName: string
}

interface PictrueList {
  list: any[]
  total: number
}

interface TreeData {
  attachmentCategoryName: string
  attachmentCategoryId: number
  children?: TreeData[]
}

/* ─── Props & Emits ─── */
const props = withDefaults(defineProps<Props>(), {
  isMore: '1',
  isIframe: false,
  isPage: false,
  pageLimit: 18,
})

const emit = defineEmits<{
  getImage: [images: string[]]
}>()

/* ─── State ─── */
const loading = ref(false)
const params = ref('')
const pids = ref('')
const treeId = ref(0)
const sleOptions = reactive({
  attachmentCategoryName: '',
  attachmentCategoryId: '',
})
const list = ref<any[]>([])
const filterText = ref('')
const treeData = ref<TreeData[]>([])
const treeData2 = ref<TreeData[]>([])
const defaultProps = reactive({
  children: 'children',
  label: 'attachmentCategoryName',
})
const classifyId = ref(0)
const myHeaders = reactive({ Authorization: 'Bearer ' + getToken() })

const tableData = reactive<TableData>({
  page: 1,
  limit: props.pageLimit,
  attachmentCategoryId: 0,
  order: '',
  attachmentName: '',
})
const pictrueList = reactive<PictrueList>({
  list: [],
  total: 0,
})
const isShowPic = ref(false)
const checkPicList = ref<any[]>([])
const ids = ref<number[]>([])
const checkedMore = ref<string[]>([])
const checkedAll = ref<string[]>([])
const selectItem = ref<any[]>([])
const lietStyle = ref('list')
const isDialog = ref(false)
const allSelect = ref(false)

// refs
const treeRef = ref()
const tableRef = ref()
const uploadRef = ref()
const imgListBoxRef = ref()


/* ─── Computed ─── */
const fileUrl = computed(() => {
  return SettingMer.https + `/upload/image/${tableData.attachmentCategoryId}/file`
})

/* ─── Watch ─── */
watch(filterText, (val) => {
  treeRef.value?.filter(val)
})

/* ─── Methods ─── */
function radioChange() {
  initData()
}

function initData() {
  checkPicList.value = []
  selectItem.value = []
  ids.value = []
  allSelect.value = false
  if (lietStyle.value == 'table') tableRef.value?.clearSelection()
  pictrueList.list.map((el: any) => {
    el.isSelect = false
    el.num = 0
  })
}

function getRowKey(row: any) {
  return row.attachmentId
}


//  选中某一行
function handleSelectRow(selection: any[]) {
  // 获取当前页所有数据的ID集合
  const currentPageIds = new Set(pictrueList.list.map(item => item.attachmentId));
  // 获取当前页选中的ID集合
  const selectedIds = new Set(selection.map(item => item.attachmentId));

  // 遍历当前页的数据，更新全局选中状态
  currentPageIds.forEach(id => {
    const index = ids.value.indexOf(id);
    const item = pictrueList.list.find(i => i.attachmentId === id);

    if (selectedIds.has(id)) {
      // 当前页选中的行，添加到全局选中
      if (index === -1) {
        ids.value.push(id);
        if (item) {
          checkPicList.value.push(item.attachmentSrc);
        }
      }
    } else {
      // 当前页取消选中的行，从全局选中移除
      if (index !== -1) {
        ids.value.splice(index, 1);
        if (item) {
          const srcIndex = checkPicList.value.indexOf(item.attachmentSrc);
          if (srcIndex !== -1) {
            checkPicList.value.splice(srcIndex, 1);
          }
        }
      }
    }
  });

  // 更新全选复选框状态
  allSelect.value = selection.length > 0 && selection.length === pictrueList.list.length;
}

function unique(arr: any[]) {
  return arr.reduce((acc: any[], curr: any) => {
    const x = acc.find((item: any) => item.attachmentId === curr.attachmentId)
    if (!x) return acc.concat([curr])
    return acc
  }, [])
}

function lookImg(item: any) {
  const viewer = document.querySelector('.images') as any
  if (viewer && viewer.$viewer) {
    viewer.$viewer.show()
    nextTick(() => {
      const i = pictrueList.list.findIndex((e: any) => e.attachmentSrc === item.attachmentSrc)
      viewer.$viewer.update().view(i)
    })
  }
}

function getList() {
  const data = {
    attachmentCategoryName: '全部图片',
    attachmentCategoryId: 0,
  }
  formatLstApi()
    .then((res: any) => {
      treeData.value = res.data
      treeData.value.unshift(data)
      treeData2.value = [...treeData.value]
    })
    .catch((res: any) => {
      ElMessage.error(res.message)
    })
}

function handleEdit(item: any) {
  if (!item.attachmentName.trim()) {
    ElMessage.warning('请先输入图片名称')
    return
  }
  picNameEditApi(item.attachmentId, { attachmentName: item.attachmentName })
    .then((res: any) => {
      item.isEdit = false
      ElMessage.success(res.message)
    })
    .catch((error: any) => {
      ElMessage.error(error.message)
    })
}

function onAdd(id: number) {
  treeId.value = id
  const config: any = {}
  if (Number(id) > 0) config.formData = { pid: id }
  ;(proxy as any).$modalForm(() => attachmentCreateApi(), config).then(() => {
    getList()
  })
}

function onEdit(id: number) {
  ;(proxy as any).$modalForm(() => attachmentUpdateApi(id)).then(() => getList())
}

function handleDelete(id: number) {
  ;(proxy as any).$modalSure().then(() => {
    attachmentDeleteApi(id)
      .then(({ message }: any) => {
        ElMessage.success(message)
        getList()
        // 删除分类后默认选中全部分类并加载全部分类图片
        treeId.value = 0;
        tableData.attachmentCategoryId = 0;
        getFileList();
      })
      .catch(({ message }: any) => {
        ElMessage.error(message)
      })
  })
}

function appendBtn(data: any) {
  treeId.value = data.attachmentCategoryId
  tableData.attachmentCategoryId = data.attachmentCategoryId
  selectItem.value = []
  checkPicList.value = []
  tableData.page = 1
  getFileList()
}

function uploadModal() {
  uploadRef.value.uploadModal = true
}

function uploadSuccess() {
  tableData.page = 1
  getFileList()
}

function enterLeave(item: any) {
  item.isShowEdit = !item.isShowEdit
}

function clickMenu(data: any, name: string) {
  if (name == '1') {
    onAdd(data.attachmentCategoryId)
  } else if (name == '2') {
    onEdit(data.attachmentCategoryId)
  } else if (name == '3') {
    handleDelete(data.attachmentCategoryId)
  }
}

function getFileList(num?: number) {
  loading.value = true
  tableData.page = num ?? tableData.page
  attachmentListApi(tableData)
    .then(async (res: any) => {
      res.data.list.forEach((el: any) => {
        el.isSelect = false
        el.isEdit = false
        el.isShowEdit = false
        el.realName = false
        el.num = 0
      })
      pictrueList.list = res.data.list
      isShowPic.value = !pictrueList.list.length
      if (route && route.query.field && route.query.field !== 'dialog') {
        checkedMore.value = getFieldValue(route.query.field as string) || []
        // 恢复列表模式的选中状态
       void nextTick(() => {
          if (lietStyle.value === 'list' && ids.length > 0) {
            // 清空当前的 selectItem，重新构建
            selectItem.value = [];

            pictrueList.list.forEach(item => {
              if (ids.value.includes(item.attachmentId)) {
                item.isSelect = true;
                selectItem.value.push(item);
              }
            });

            // 更新序号
            pictrueList.list.forEach((el, i) => {
              if (el.isSelect) {
                const idx = selectItem.value.findIndex(el2 => el.attachmentId == el2.attachmentId);
                el.num = idx + 1;
              } else {
                el.num = 0;
              }
            });

            // 更新全选状态
            const currentPageSelectedCount = pictrueList.list.filter(el => el.isSelect).length;
            allSelect.value = currentPageSelectedCount === pictrueList.list.length && pictrueList.list.length > 0;
          } else if (lietStyle.value === 'table' && tableRef.value && ids.value.length > 0) {
            // 表格模式恢复选中
            pictrueList.list.forEach(item => {
              if (ids.value.includes(item.attachmentId)) {
                tableRef.value.toggleRowSelection(item, true);
              }
            });
            // 更新表格的全选状态
            const selection = tableRef.value.selection || [];
            allSelect.value = selection.length === pictrueList.list.length && pictrueList.list.length > 0;
          } else {
            // 没有选中数据时，确保全选状态为 false
            allSelect.value = false;
          }
        });
      }
      pictrueList.total = res.data.count
      loading.value = false
    })
    .catch((res: any) => {
      ElMessage.error(res.message)
      loading.value = false
    })
}

function pageChange(page: number) {
  tableData.page = page
  // 翻页时只清空当前页的视觉状态，不清空全局选中的数据
  if (lietStyle.value === 'list') {
    pictrueList.list.forEach(item => {
      item.isSelect = false;
      item.num = 0;
    });
  }
  if (lietStyle.value === 'table' && tableRef.value) {
    tableRef.value.clearSelection();
  }
  selectItem.value = []
  checkPicList.value = []
  ids.value = []
  allSelect.value = false
  getFileList()
}

function handleSizeChange(val: number) {
  tableData.limit = val
  getFileList()
}


// 选中图片
function changImage(item: any, index: number, row: any[]) {
  if (!item.isSelect) {
    // 选中
    item.isSelect = true
    selectItem.value.push(item)
    checkPicList.value.push(item.attachmentSrc)
    ids.value.push(item.attachmentId)
  } else {
    // 取消选中
    item.isSelect = false;
    const idIndex = ids.value.indexOf(item.attachmentId);
    if (idIndex > -1) ids.value.splice(idIndex, 1);

    const selectIndex = selectItem.value.findIndex(o => o.attachmentId == item.attachmentId);
    if (selectIndex > -1) selectItem.value.splice(selectIndex, 1);

    const srcIndex = checkPicList.value.indexOf(item.attachmentSrc);
    if (srcIndex > -1) checkPicList.value.splice(srcIndex, 1);
  }

  // 更新序号
  pictrueList.list.forEach((el, i) => {
    if (el.isSelect) {
      const idx = selectItem.value.findIndex(el2 => el.attachmentId == el2.attachmentId);
      el.num = idx + 1;
    } else {
      el.num = 0;
    }
  });

  // 更新全选按钮状态
  const currentPageSelectedCount = pictrueList.list.filter(el => el.isSelect).length;
  allSelect.value = currentPageSelectedCount === pictrueList.list.length && pictrueList.list.length > 0;
}

function checkPics(isButton?: boolean) {
  if (checkPicList.value.length) {
    if (route) {
      const field = route.query.field as string

      if (route.query.type === '1') {
        if (checkPicList.value.length > 1) return ElMessage.warning('最多只能选一张图片')
        setFieldValue(field, checkPicList.value[0])
        if (isButton) closeField(field)
      }

      if (route.query.type === '2') {
        checkedAll.value = [...checkedMore.value, ...checkPicList.value]
        setFieldValue(field, Array.from(new Set(checkedAll.value)))
        closeField(field)
      }

      if (route.query.field === 'dialog') {
        let str = ''
        for (let i = 0; i < checkPicList.value.length; i++) {
          str += '<img src="' + checkPicList.value[i] + '">'
        }
        ;(window as any).nowEditor.editor.execCommand('insertHtml', str)
        ;(window as any).nowEditor.dialog.close(true)
      }
      emit('getImage', checkPicList.value)
    } else {
      if (props.isMore === '1' && checkPicList.value.length > 1) {
        return ElMessage.warning('最多只能选一张图片')
      }
      emit('getImage', checkPicList.value)
    }
  } else {
    ElMessage.warning('请先选择图片')
  }
}

function deletePic(item: any) {
  ids.value = [item.attachmentId]
  deletePicList()
}


// 删除图片
function deletePicList() {
  const idsToDelete = [...ids.value]; // 保存要删除的ID列表
  if (!idsToDelete.length) return;

  ElMessageBox.confirm('确定删除图片?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    picDeleteApi({ ids: idsToDelete })
        .then(({ message }) => {
          ElMessage.success(message);

          // 从全局选中中移除已删除的项
          idsToDelete.forEach(id => {
            // 从 ids 数组中移除
            const idIndex = ids.value.indexOf(id);
            if (idIndex !== -1) {
              ids.value.splice(idIndex, 1);
            }

            // 从 checkPicList 中移除对应的图片URL
            const srcIndex = checkPicList.value.findIndex(src => {
              const item = pictrueList.list.find(i => i.attachmentId === id);
              return item && src === item.attachmentSrc;
            });
            if (srcIndex !== -1) {
              checkPicList.value.splice(srcIndex, 1);
            }

            // 从 selectItem 中移除
            const selectIndex = selectItem.value.findIndex(i => i.attachmentId === id);
            if (selectIndex !== -1) {
              selectItem.value.splice(selectIndex, 1);
            }
          });

          // 重新获取列表
          getFileList();
          spliceDeleteList();

          // 注意：不要调用 initData()，因为那会清空所有选中状态
          // 但需要重置当前页的视觉选中状态，因为数据已经刷新
          nextTick(() => {
            // 重置全选状态
            allSelect .value= false;
          });
        })
        .catch(({ message }) => {
          ElMessage.error(message);
        });
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '已取消'
    });
  });
}



function spliceDeleteList() {
  selectItem.value = selectItem.value.filter(
    (el: any) => !ids.value.includes(el.attachmentId)
  )
}

function handleSelClick(status: boolean) {
  if (!status) {
    getMove()
  } else {
    if (!ids.value.toString()) {
      ElMessage.warning('请先选择图片')
      return
    }
  }
}

function getMove() {
  if (!ids.value.toString()) return
  if (pids.value === '') {
    ElMessage.warning('请选择分类')
    return
  }
  categoryApi(ids.value, pids.value)
    .then(async (res: any) => {
      ElMessage.success(res.message)
      pids.value = ''
      initData()
      getFileList()
    })
    .catch((res: any) => {
      pids.value = ''
      initData()
      ElMessage.error(res.message)
    })
}



// 全选功能 - 切换全选和取消全选
function selectAll(val:any) {
  if (lietStyle.value === 'table') {
    // 表格模式
    if (tableRef.value) {
      if (val) {
        pictrueList.list.forEach(row => {
          tableRef.value.toggleRowSelection(row, true);
        });
      } else {
        tableRef.value.clearSelection();
      }
    }
    return;
  }

  // 列表模式
  if (val) {
    // 全选：选中当前页所有未选中的项
    pictrueList.list.forEach((item) => {
      if (!item.isSelect) {
        item.isSelect = true;
        checkPicList.value.push(item.attachmentSrc);
        ids.value.push(item.attachmentId);
        selectItem.value.push(item);
      }
    });
  } else {
    // 取消全选：取消当前页所有选中的项
    pictrueList.list.forEach((item) => {
      if (item.isSelect) {
        item.isSelect = false;
        item.num = 0;

        const idIndex = ids.value.indexOf(item.attachmentId);
        if (idIndex > -1) ids.value.splice(idIndex, 1);

        const selectIndex = selectItem.value.findIndex(i => i.attachmentId === item.attachmentId);
        if (selectIndex > -1) selectItem.value.splice(selectIndex, 1);

        const srcIndex = checkPicList.value.indexOf(item.attachmentSrc);
        if (srcIndex > -1) checkPicList.value.splice(srcIndex, 1);
      }
    });
  }

  // 更新序号
  pictrueList.list.forEach((el, i) => {
    if (el.isSelect) {
      const idx = selectItem.value.findIndex(el2 => el.attachmentId == el2.attachmentId);
      el.num = idx + 1;
    } else {
      el.num = 0;
    }
  });
}

/* ─── Lifecycle ─── */
onMounted(() => {
  params.value = route && route.path ? route.path : ''

  // 响应式布局：根据容器宽度计算每页显示数量
  nextTick(() => {
    if (props.isPage && imgListBoxRef.value) {
      const containerWidth = imgListBoxRef.value.clientWidth;
      const itemWidth = 156; // 图片项宽度（含间距）
      const col = Math.floor(containerWidth / itemWidth); // 计算每行显示数量
      const row = Math.floor((document.body.clientHeight - imgListBoxRef.value.clientHeight - 325) / 180); // 计算行数
      tableData.limit = Math.max(col * row, tableData.limit); // 更新每页数量
    }
  });
  getList()
  getFileList()
  if ((route && route.query.field) || !route) isDialog.value = true
  if (route && route.query.field === 'dialog') {
    isDialog.value = true
    onOk(() => {
      checkPics()
    })
  }
})
</script>

<style scoped lang="scss">
.Nav {
  width: 220px;
  border-right: 1px solid #eee;
  overflow: auto;
}

.picture-count {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
}

.nav-wrapper {
  width: 220px;
  height: 100%;
  position: relative;
}

.abs-full {
  position: absolute;
  inset: 0;
  overflow: auto;
}

.flex-end {
  display: flex;
  box-pack: end;
  justify-content: flex-end;
}

.selectTreeClass {
  background: #d5e8fc;
}

:deep(.ones th) {
  background: #F0F5FF;
}

.treeBox {
  width: 100%;
  height: 100%;
}

.upload-demo {
  display: inline-block !important;
}

.is-modal .pictrueList_pic {
  width: 99px;
  margin-right: 10px !important;

  img {
    width: 100%;
    height: 99px;
  }
}

.tabBox_img {
  display: flex;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;

  img {
    width: 100%;
  }
}

.real-name {
  flex: 1;
}

.df-aic {
  display: flex;
  align-items: center;

}

.tree_w {
  padding: 20px 30px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  padding-right: 17px;
  height: 36px;
  color: rgba(0, 0, 0, .6);
  overflow: hidden;
  .add {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: rgba(0, 0, 0, .6);
    cursor: pointer;
    padding: 2px 4px;
    outline: none;
  }
}

.is-current .custom-tree-node,
.is-current .custom-tree-node .add {
  color: var(--prev-color-primary);
}

:deep(.el-tree-node) {
  position: relative;
}

:deep(.is-current::after) {
  content: "";
  display: block;
  width: 2px;
  height: 40px;
  background: var(--prev-color-primary);
  position: absolute;
  right: 0;
  top: 0;
}

:deep(.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content) {
  background: rgba(67, 127, 253, .04);
}

.el-ic {
  display: none;

  i,
  span {
    font-size: 18px;
    font-weight: 600;
  }

  .svg-icon {
    color: var(--prev-color-primary);
  }
}

.el-tree-node__expand-icon {
  color: var(--prev-color-primary);
}

:deep(.el-tree-node__content) {
  height: 40px;
}

.el-tree-node__content:hover .el-ic {
  color: var(--prev-color-primary) !important;
  display: inline-block;
}

.el-dialog__body {
  .upload-container .image-preview .image-preview-wrapper img {
    height: 100px;
  }

  .el-dialog .el-collapse-item__wrap {
    padding-top: 0px;
  }

  .spatial_img {
    .el-collapse-item__wrap {
      margin-bottom: 0;
      padding-top: 0px;
    }
  }

  .upload-container .image-preview .image-preview-wrapper {
    width: 120px;
  }

  .upload-container .image-preview .image-preview-action {
    line-height: 100px;
    height: 100px;
  }
}

.trees-coadd {
  width: 100%;
  border-radius: 4px;
  // overflow: hidden;
  position: relative;

  .scollhide {
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 10px 0 10px 0;
    box-sizing: border-box;

    // height: calc(100vh - 150px);
    .trees {
      width: 100%;
      // max-height: 400px;
    }
  }

  .scollhide::-webkit-scrollbar {
    display: none;
  }
}

.conters {
  display: flex;
  flex-wrap: wrap;
}

.gridPic {
  width: 146px;
  cursor: pointer;
  position: relative;
  margin: 10px 5px 0 5px !important;
  overflow: hidden;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: 20px;
    font-size: 12px;
    color: #515a6d;
    text-align: center;
    margin: 10px 0 0;
  }

  .img {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(248, 248, 248);
    padding: 2px;

    img {
      width: 140px;
      height: 140px;
      object-fit: contain;
    }
  }

  &.gridSmall {
    width: 100px;

    img {
      width: 96px;
      height: 96px;
      object-fit: contain;
    }
  }

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #515a6e;
    font-size: 12px;
  }

  .number {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
  }

  .demo-badge {
    width: 42px;
    height: 42px;
    background: transparent;
    border-radius: 6px;
    display: inline-block;
  }
}

.gridPic :deep(.el-badge__content) {
  position: absolute;
  transform: translateX(50%);
  top: 0;
  right: 14px;
  height: 20px;
  border-radius: 10px;
  min-width: 20px;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.upload-body {
  flex: 1;
}

.upload-body-content {
  inset: 0;
  overflow: auto;
}

.conter {
  flex: 1;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;

  .bnt {
    width: 100%;
    padding: 0 0px 20px 15px;
    box-sizing: border-box;
  }

  .pictrueList {
    width: 100%;
    overflow-y: auto;

    el-image {
      width: 100%;
      border: 2px solid #fff;
    }

    .on {
      border: 2px solid #5fb878;
    }
  }

  .el-image {
    width: 110px;
    height: 110px;
    cursor: pointer;
  }

  .imagesNo {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: 65px auto;

    .imagesNo_sp {
      font-size: 13px;
      color: #dbdbdb;
      line-height: 3;
    }
  }
}

/* 外层：名称在上、操作在下（EB 外层误写 style 未套 flex，实际是纵向） */
.operate-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}

/* 内层操作行：删除 / 重命名 / 查看 横向排列 */
.operate-height {
  flex-direction: row;
  height: 16px;
}

.operate {
  color: var(--prev-color-primary);
  font-size: 12px;
  white-space: nowrap;
}

.w-20 {
  width: 20px;
}

.ml-20 {
  margin-left: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mr-14 {
  margin-right: 14px;
}

/* 左侧操作：按钮等高；勿对 cascader 强改 wrapper 高度（会把箭头拆成第二框） */
.pic-toolbar-left {
  flex: 1;
  min-width: 0;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0;
  :deep(.el-button) {
    --el-button-size: 32px;
    height: 32px;
    margin-left: 0 !important;
    margin-right: 10px;
    padding: 0 15px;
  }
  :deep(.el-cascader) {
    display: inline-flex;
    width: 150px;
    vertical-align: middle;
    .el-input {
      width: 100%;
      --el-component-size: 32px;
    }
    .el-input__wrapper {
      min-height: 32px !important;
      width: 100%;
    }
    /* 覆盖全局 .el-input__inner 边框，避免箭头处上下线断裂 */
    .el-input__inner {
      height: auto !important;
      line-height: normal !important;
      border: none !important;
      background-color: transparent !important;
      box-shadow: none !important;
    }
  }
}

/* 搜索 + 宫格/列表：一行垂直居中 */
.pic-toolbar-right {
  flex-shrink: 0;
  align-items: center;
  flex-wrap: nowrap;
  .pic-search-input {
    :deep(.el-input__wrapper) {
      min-height: 32px;
      padding-right: 8px;
    }
  }
  .pic-search-icon {
    cursor: pointer;
    color: var(--el-text-color-placeholder);
    &:hover {
      color: var(--prev-color-primary, var(--el-color-primary));
    }
  }
  .pic-view-toggle {
    display: inline-flex;
    align-items: center;
    :deep(.el-radio-button__inner) {
      height: 32px;
      padding: 0 11px;
      line-height: 30px;
      box-sizing: border-box;
    }
  }
}

.w-90-p111 {
  width: 90%;
}

/* 列表操作：文字链单行（对齐 EB type=text） */
.pic-table-ops {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  :deep(.el-button) {
    margin-left: 0;
    margin-right: 8px;
    padding: 0;
    height: auto;
    &:last-child {
      margin-right: 0;
    }
  }
}

.flex-between-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 14px;
  margin-left: 20px;
}

.flex-end {
  justify-content: flex-end !important;
}

.w-150 {
  width: 150px;
}

.upload-pictures-wrapper {
  height: 600px;
  background: #fff;
}
</style>
